import { useAuth } from '@domain/auth/auth.hook';
import React, { useState } from 'react';
import { CancelToken } from 'axios';
import { usePagedData } from '@domain/hooks/use.paged.data';
import { FormControl, FormHelperText, InputLabel } from '@material-ui/core';
import { DiffsComboProps } from '@screens/players/player.details.tabs/diffs/diffs.props';
import { DiffsComboBoxStyled, DiffsSelect } from '@screens/players/player.details.tabs/diffs/diffs.combobox.styles';

const DiffsComboBox = ({ onChange, comboLabel, by }: DiffsComboProps) => {
  const { authorizedServices } = useAuth();
  function selectStats(e: React.ChangeEvent<HTMLInputElement | { name?: string; value: unknown; type?: string; checked?: boolean }>) {
    e.preventDefault();
    onChange(e.target.value as string);
  }

  const comboboxLabel = comboLabel;

  async function getStatsAction(data: any, page: number, cancelToken: CancelToken | undefined) {
    return authorizedServices.get('/admin/diffs/stats-action', { params: { by }, cancelToken });
  }
  const { responseData, loading, validationErrors } = usePagedData(by, getStatsAction, {});

  const statsActionData = responseData?.values ?? [];

  const [currentValueSelected, setComboSelected] = useState('');

  function handleComboboxChange(e: React.ChangeEvent<HTMLInputElement | { name?: string; value: unknown; type?: string; checked?: boolean }>) {
    setComboSelected(e.target.value as string);
    selectStats(e);
  }

  return (
    <>
      <DiffsComboBoxStyled>
        <FormControl>
          <InputLabel id='diffsComboBox'>{comboboxLabel}</InputLabel>
          <DiffsSelect
            native
            labelId='diffsComboBox'
            id='diffsComboBox'
            inputProps={{ name: 'diffsComboBox' }}
            disabled={loading}
            onChange={handleComboboxChange}
            value={currentValueSelected}
          >
            <option value={-1}>N/A</option>
            {statsActionData.map((v: any) => (
              <option key={Object.keys(v).toString()} value={Object.keys(v).toString()}>
                {Object.values(v).toString()}
              </option>
            ))}
          </DiffsSelect>
          <FormHelperText error>{validationErrors}</FormHelperText>
        </FormControl>
      </DiffsComboBoxStyled>
    </>
  );
};

export default DiffsComboBox;
